import type { MediaContainerDesign } from '@wix/thunderbolt-becky-types'
import { parseCss } from '../../schemas/css/Css.utils'
import _ from 'lodash'

export const getContainerStyle = (compDesign?: MediaContainerDesign) => {
	if (compDesign?.cssStyle) {
		const containerStyle = parseCss(compDesign.cssStyle)

		const transformCss = _.has(containerStyle, ['borderRadius']) ? { transform: 'translateZ(0)' } : {}

		const borderWidth = _.get(containerStyle, ['borderWidth'])
		const marginCss = borderWidth ? { margin: `-${parseInt(borderWidth, 10)}px` } : {}

		return {
			..._.mapKeys(containerStyle, (__, key) => _.kebabCase(key)),
			overflow: 'hidden',
			...transformCss,
			...marginCss,
		}
	}

	return {}
}
